import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Cookies from "js-cookie";
import Header from "../../components/user/Header";
import Footer from "../../components/user/Footer";
import infoBg from "../../images/basketball2.jpg";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function Signup() {
  const API_URL = BASE_URL + "/adduser";
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const username = formData.get("username");
    const firstName = formData.get("firstName");
    const lastName = formData.get("lastName");
    const email = formData.get("email");
    const dob = formData.get("dob");
    const jerseyNumber = formData.get("jerseyNumber");
    const address = formData.get("address");
    const schoolClub = formData.get("schoolClub");
    const graduationYear = formData.get("graduationYear");
    const password = formData.get("password");
    const confirmPassword = formData.get("confirmPassword");

    // ✅ Validation
    if (
      !username ||
      !firstName ||
      !lastName ||
      !email ||
      !dob ||
      !jerseyNumber ||
      !address ||
      !schoolClub ||
      !graduationYear ||
      !password ||
      !confirmPassword
    ) {
      toast.error("All fields are required!");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    const data = { 
        Role: "User", // ✅ fixed role 
        Name: username, 
        FirstName: firstName, 
        LastName: lastName, 
        Email: email, 
        DateOfBirth: dob, 
        JerseyNumber: jerseyNumber, 
        Address: address, 
        SchoolClub: schoolClub, 
        GraduationYear: graduationYear, 
        Password: password, 
    };

    axios
      .post(API_URL, data, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.message === "Username already exist") {
          toast.error("This username already exists!");
        } else if (res.data.message === "Account created successfully") {
          toast.success("Account created successfully!");

          // ✅ Auto login (set cookies)
          let date = new Date();
          date.setTime(date.getTime() + 10 * 60 * 60 * 1000); // 10 hours

          Cookies.set("username", username, { expires: date });
          Cookies.set("user_role", "User", { expires: date });

          // ✅ Redirect to athlete profile
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(error.response.data.message);
      });
  };

  return (
    <>
        <Header />
        <section
          className="py-5 position-relative text-white d-flex align-items-center"
          style={{
              backgroundImage: `url(${infoBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              height: "400px",
          }}
          >
          {/* Dark Overlay */}
          <div
              style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.55)",
              zIndex: 1,
              }}
          ></div>
  
          {/* Content */}
          <div
              className="container text-center position-relative"
              style={{ zIndex: 2 }}
          >
              <h2 className="fw-bold">Create Your Athlete Account Here</h2>
  
              <p className="lead mt-3">
              Create your official NLSA athlete account to track your performance, earn certifications, and join the nationwide leaderboard.<br />
              Sign up today and take the first step toward proving your skills and achieving your athletic goals.
              </p>
          </div>
        </section>
        <div className="container">
        <ToastContainer />
        <br />
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-sm-6">
                <label htmlFor="username">Username*</label>
                <input
                    type="text"
                    id="username"
                    placeholder="Enter Username"
                    className="form-control"
                    name="username"
                    required
                />
                </div>
                <div className="col-sm-6">
                <label htmlFor="email">Email*</label>
                <input
                    type="email"
                    id="email"
                    placeholder="Enter Email"
                    className="form-control"
                    name="email"
                    required
                />
                </div>
            </div>
            <br />

            <div className="row">
                <div className="col-sm-6">
                <label htmlFor="firstName">First Name*</label>
                <input
                    type="text"
                    id="firstName"
                    placeholder="First Name"
                    className="form-control"
                    name="firstName"
                    required
                />
                </div>
                <div className="col-sm-6">
                <label htmlFor="lastName">Last Name*</label>
                <input
                    type="text"
                    id="lastName"
                    placeholder="Last Name"
                    className="form-control"
                    name="lastName"
                    required
                />
                </div>
            </div>
            <br />

            <div className="row">
                <div className="col-sm-6">
                <label htmlFor="dob">Date of Birth*</label>
                <input
                    type="date"
                    id="dob"
                    className="form-control"
                    name="dob"
                    required
                />
                </div>
                <div className="col-sm-6">
                <label htmlFor="jerseyNumber">Jersey Number*</label>
                <input
                    type="text"
                    id="jerseyNumber"
                    placeholder="Jersey Number"
                    className="form-control"
                    name="jerseyNumber"
                    required
                />
                </div>
            </div>
            <br />

            <div className="row">
                <div className="col-sm-6">
                <label htmlFor="address">Address*</label>
                <input
                    type="text"
                    id="address"
                    placeholder="Address"
                    className="form-control"
                    name="address"
                    required
                />
                </div>
                <div className="col-sm-6">
                <label htmlFor="schoolClub">School / Club*</label>
                <input
                    type="text"
                    id="schoolClub"
                    placeholder="School / Club"
                    className="form-control"
                    name="schoolClub"
                    required
                />
                </div>
            </div>
            <br />

            <div className="row">
                <div className="col-sm-6">
                <label htmlFor="graduationYear">Graduation Year*</label>
                <input
                    type="month"
                    id="graduationYear"
                    className="form-control"
                    name="graduationYear"
                    required
                />
                </div>
            </div>
            <br />

            <div className="row">
                <div className="col-sm-6">
                <label htmlFor="password">Password*</label>
                <input
                    type="password"
                    id="password"
                    placeholder="Password (8-20 characters)"
                    className="form-control"
                    name="password"
                    required
                />
                </div>
                <div className="col-sm-6">
                <label htmlFor="confirmPassword">Confirm Password*</label>
                <input
                    type="password"
                    id="confirmPassword"
                    placeholder="Confirm Password"
                    className="form-control"
                    name="confirmPassword"
                    required
                />
                </div>
            </div>
            <br />

            <div className="row">
                <div className="col-sm-6">
                <button className="btn btn-primary">Create Account</button>
                </div>
            </div>
        </form>
        </div>
        <br /><br />
      <Footer />
    </>
  );
}
